import { createSelector } from 'reselect';
import get from 'lodash/get';

import { KPI_DIMENSIONS_MAP } from '@src/utils/kpi';
import { metricKeys } from '@pulse/metrics';
import { BenchmarkTabKey } from '@store/overviewDashboard/kpiData/reducer';
import { kpiMetricSelector } from '../base/selectors';
import { SCOPE } from './types';

const selector = (state) => get(state, SCOPE);

export const benchmarkTableColumnsSelector = createSelector(
  kpiMetricSelector,
  (kpiMetric) => KPI_DIMENSIONS_MAP[kpiMetric || metricKeys.StreamingPerformanceIndex],
);
export const benchmarkStore = createSelector(selector, (state) => state.benchmark);
export const kpiStore = createSelector(selector, (state) => state[BenchmarkTabKey]);
export const spiStore = createSelector(selector, (state) => state.benchmarkSPI);
export const supportedMetricsStore = createSelector(selector, (state) => state.supportedMetrics);

export const benchmarkDimenstionSelector = (dimension) => (state) => {
  const benchmarkData = benchmarkStore(state);
  return get(benchmarkData, [dimension, 'response', 'result'], []);
};

export const kpiLoadingSelector = createSelector(kpiStore, (kpiStore) => ({
  loading: kpiStore.isFetching,
  showError: kpiStore.errorCode !== 406 && kpiStore.errorCode !== 0,
  errorMsg: kpiStore.errorMsg,
}));

export const kpiDataSelector = createSelector(kpiStore, (kpiStore) => {
  return {
    response: kpiStore.response,
  };
});

export const spiSelector = createSelector(spiStore, (spiStore) => {
  const spiData = get(spiStore, ['response', 'benchmarkData'], {});
  return spiData;
});

export const spiValueSelector = createSelector(spiSelector, (spiSelector) => {
  const spiData = get(spiSelector, ['result', 0, metricKeys.StreamingPerformanceIndex], '');
  return spiData;
});

export const spiValueBestSelector = createSelector(spiSelector, (spiSelector) => {
  const spiData = get(spiSelector, ['result', 0, metricKeys.StreamingPerformanceIndexBest], '');
  return spiData;
});

export const spiIntervalSelector = createSelector(spiSelector, (spiSelector) => {
  const spiData = get(spiSelector, 'adjustedInterval', '');
  return spiData;
});

export const spiLoadingSelector = createSelector(spiStore, (spiStore) => ({
  loading: spiStore.isFetching,
  showError: spiStore.errorCode !== 0 || spiStore.errorMsg,
  errorMsg: spiStore.errorMsg,
}));

export const supportedMetricsSelector = createSelector(
  supportedMetricsStore,
  (supportedMetricsStore) => {
    return {
      response: supportedMetricsStore.response,
    };
  },
);

export default selector;
